@use '~/theme/theme' as *;
@use '~/theme/typography';

.container {
  display: grid;
  grid-template-columns: max-content auto;
  align-items: center;
  gap: spacing(2);
  flex-direction: column;
  padding: spacing(2);
  border-radius: var(--border-radius-sm);
  background-color: color(grey-100);
}

.notesTitle {
  align-self: flex-start;
}

.attachments {
  display: flex;
  flex-wrap: wrap;
  gap: spacing(1);
}

.attachment {
  display: flex;
  align-items: center;
  padding: spacing(1);
  gap: spacing(2);
  border-color: color(grey-400);
  background-color: white;
  max-width: 250px;

  &:hover {
    color: color(grey-800);
    border-color: color(grey-400);
  }
}

.attachmentIcon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.downloadIcon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.tooltip {
  max-width: 900px;
  white-space: pre-wrap;
}
